// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Dashboard.css - Design Oficial, Creativ și Responsive --- */

:root {
  /* Paletă de culori inspirată din imaginea originală */
  --primary-yellow: #f4b400; /* Galbenul din logo-ul original */
  --accent-yellow-dark: #d8a000;
  --bg-main: #f0f2f5; /* Gri foarte deschis profesional */
  --white: #ffffff;
  --text-main: #1c1e21; /* Negru soft */
  --text-muted: #606770; /* Gri pentru subtitluri */
  --red-alert: #d93025; /* Roșu pentru logout, similar butonu-ului 'Caută' */
  --shadow-sm: 0 2px 4px rgba(0,0,0,0.08);
  --shadow-md: 0 4px 12px rgba(0,0,0,0.1);
  --transition-fast: all 0.2s ease-in-out;
  --border-radius-lg: 16px;
  --border-radius-md: 10px;
}

/* Reset de bază pentru consistență */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: var(--bg-main);
  font-family: 'Baloo 2', cursive;
  color: var(--text-main);
  margin:auto;
  line-height: 1;
}

/* --- Container Principal Desktop (Layout pe Coloane) --- */
.dashboard {
  display: grid;
  grid-template-columns: 280px 1fr; /* Panou lateral fix + Zonă conținut */
  grid-template-rows: auto 1fr; /* Header sus, conținut jos */
  min-height: 100vh;
}

/* --- 1. Panoul Lateral (Sidebar) --- */
.dashboard-tabs {
  grid-row: 1 / -1; /* Ocupă toată înălțimea */
  background-color: var(--white);
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-right: 1px solid rgba(0,0,0,0.05);
  box-shadow: var(--shadow-sm);
  z-index: 10;
}

/* Logo-ul cu lăbuță integrat în sidebar */
.dashboard-tabs::before {
  display: none;
  content: '🐾 FindMyPet';
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--primary-yellow);
  margin-bottom: 40px;
  text-align: center;
}

/* Butoanele de Navigare (Tab-uri) */
.tab {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  background: transparent;
  border: none;
  border-radius: var(--border-radius-md);
  color: var(--text-muted);
  font-size: 1rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: var(--transition-fast);
  width: 100%;
}

.tab:hover {
  background-color: rgba(244, 180, 0, 0.08); /* Galben translucid */
  color: var(--accent-yellow-dark);
}

.tab.active {
  background-color: var(--primary-yellow);
  color: black;
  box-shadow: 0 4px 10px rgba(244, 180, 0, 0.3);
}

/* Icoane (adăugate prin pseudo-elemente pentru un aspect curat) */
.tab[onClick*="posteaza"]::before { content: '➕'; margin-right: 12px; }
.tab[onClick*="lista"]::before { content: '📋'; margin-right: 12px; }


/* --- 2. Header-ul Superioar (Zonă Utilizator) --- */
.dashboard-header {
  grid-column: 2; /* Lângă sidebar */
  background-color: var(--white);
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  box-shadow: var(--shadow-sm);
}

/* Titlul paginii mutat în stânga header-ului */
.dashboard-header-title-group {
  display: flex;
  flex-direction: column;
}

.dashboard-header h1 {
  font-size: 1.6rem;
  font-weight: 700;
  font-family: 'Baloo 2', cursive;
  color: #f2c94c; /* galben */
    text-shadow:
    1px 1px 0 black,
    -1px 1px 0 black,
    1px -1px 0 black,
    -1px -1px 0 black;
}

.dashboard-header p {
  color: var(--text-muted);
  font-size: 0.95rem;
}

/* Zona de Profil din dreapta */
.dashboard-user {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: var(--bg-main);
  padding: 10px 20px;
  border-radius: 50px; /* Stil "pill" profesional */
}

.dashboard-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid black;
  object-fit: cover;
}

.dashboard-user span {
  font-weight: 600;
  color: var(--text-main);
  font-size: 0.95rem;
}

.btn-logout {
  background-color: transparent;
  border: 1px solid #d1d9e0;
  color: var(--text-muted);
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  transition: var(--transition-fast);
}

.btn-logout:hover {
  background-color: var(--red-alert);
  color: var(--white);
  border-color: var(--red-alert);
  box-shadow: 0 2px 5px rgba(217, 48, 37, 0.3);
}

/* --- 3. Zona de Conținut Principal --- */
.dashboard-content {
  grid-column: 2; /* Lângă sidebar */
  padding: 40px;
  background-color: var(--bg-main);
}

/* Card-ul alb care conține formularele/listele */
.formular-container, .lista-container {
  background-color: var(--white);
  padding: 30px;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid rgba(0,0,0,0.03);
}

/* --- Stare de Încărcare (Loading) --- */
.loading {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--white);
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--primary-yellow);
}

/* --- 📱 RESPONSIVE DESIGN (Media Queries) --- */

/* Pentru Tablete și Ecrane Medii (sub 1024px) */
@media (max-width: 1024px) {
  .dashboard {
    grid-template-columns: 1fr; /* O singură coloană */
  }

  /* Sidebar-ul devine o bară orizontală jos sau sus */
  .dashboard-tabs {
    grid-row: auto;
    flex-direction: row;
    justify-content: center;
    padding: 15px;
    border-right: none;
    border-bottom: 1px solid rgba(0,0,0,0.05);
    position: sticky;
    top: 0;
    margin-bottom: 0;
  }

  .dashboard-tabs::before {
    display: none; /* Ascundem textul logo pe tab-uri mobile */
  }

  .tab {
    padding: 10px 15px;
    font-size: 0.9rem;
    justify-content: center;
  }

  .dashboard-header, .dashboard-content {
    grid-column: 1;
  }
}

/* Pentru Telefoane (sub 768px) */
@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    text-align: center;
    gap: 15px;
    padding: 20px;
  }

  .dashboard-user {
    width: 100%;
    justify-content: center;
  }

  .dashboard-content {
    padding: 20px;
  }

  .formular-container, .lista-container {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,sDAAsD;EACtD,yBAAyB,EAAE,kCAAkC;EAC7D,6BAA6B;EAC7B,kBAAkB,EAAE,mCAAmC;EACvD,gBAAgB;EAChB,oBAAoB,EAAE,eAAe;EACrC,qBAAqB,EAAE,0BAA0B;EACjD,oBAAoB,EAAE,oDAAoD;EAC1E,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,gCAAgC,EAAE,sCAAsC;EACxE,4BAA4B,EAAE,6BAA6B;EAC3D,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB,EAAE,0BAA0B;EAC5C,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wCAAwC;EACxC,4BAA4B;EAC5B,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,yCAAyC,EAAE,sBAAsB;EACjE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,6CAA6C;AAC/C;;AAEA,kEAAkE;AAClE,oCAAoC,YAAY,EAAE,kBAAkB,EAAE;AACtE,iCAAiC,aAAa,EAAE,kBAAkB,EAAE;;;AAGpE,qDAAqD;AACrD;EACE,cAAc,EAAE,kBAAkB;EAClC,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc,EAAE,WAAW;IACzB;;;;qBAIiB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA,0CAA0C;AAC1C;EACE,cAAc,EAAE,kBAAkB;EAClC,aAAa;EACb,gCAAgC;AAClC;;AAEA,iDAAiD;AACjD;EACE,8BAA8B;EAC9B,aAAa;EACb,sCAAsC;EACtC,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,iDAAiD;;AAEjD,gDAAgD;AAChD;EACE;IACE,0BAA0B,EAAE,sBAAsB;EACpD;;EAEA,oDAAoD;EACpD;IACE,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,MAAM;IACN,gBAAgB;EAClB;;EAEA;IACE,aAAa,EAAE,2CAA2C;EAC5D;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* --- Dashboard.css - Design Oficial, Creativ și Responsive --- */\n\n:root {\n  /* Paletă de culori inspirată din imaginea originală */\n  --primary-yellow: #f4b400; /* Galbenul din logo-ul original */\n  --accent-yellow-dark: #d8a000;\n  --bg-main: #f0f2f5; /* Gri foarte deschis profesional */\n  --white: #ffffff;\n  --text-main: #1c1e21; /* Negru soft */\n  --text-muted: #606770; /* Gri pentru subtitluri */\n  --red-alert: #d93025; /* Roșu pentru logout, similar butonu-ului 'Caută' */\n  --shadow-sm: 0 2px 4px rgba(0,0,0,0.08);\n  --shadow-md: 0 4px 12px rgba(0,0,0,0.1);\n  --transition-fast: all 0.2s ease-in-out;\n  --border-radius-lg: 16px;\n  --border-radius-md: 10px;\n}\n\n/* Reset de bază pentru consistență */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  background-color: var(--bg-main);\n  font-family: 'Baloo 2', cursive;\n  color: var(--text-main);\n  margin:auto;\n  line-height: 1;\n}\n\n/* --- Container Principal Desktop (Layout pe Coloane) --- */\n.dashboard {\n  display: grid;\n  grid-template-columns: 280px 1fr; /* Panou lateral fix + Zonă conținut */\n  grid-template-rows: auto 1fr; /* Header sus, conținut jos */\n  min-height: 100vh;\n}\n\n/* --- 1. Panoul Lateral (Sidebar) --- */\n.dashboard-tabs {\n  grid-row: 1 / -1; /* Ocupă toată înălțimea */\n  background-color: var(--white);\n  padding: 40px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  border-right: 1px solid rgba(0,0,0,0.05);\n  box-shadow: var(--shadow-sm);\n  z-index: 10;\n}\n\n/* Logo-ul cu lăbuță integrat în sidebar */\n.dashboard-tabs::before {\n  display: none;\n  content: '🐾 FindMyPet';\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--primary-yellow);\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n/* Butoanele de Navigare (Tab-uri) */\n.tab {\n  display: flex;\n  align-items: center;\n  padding: 14px 20px;\n  background: transparent;\n  border: none;\n  border-radius: var(--border-radius-md);\n  color: var(--text-muted);\n  font-size: 1rem;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  width: 100%;\n}\n\n.tab:hover {\n  background-color: rgba(244, 180, 0, 0.08); /* Galben translucid */\n  color: var(--accent-yellow-dark);\n}\n\n.tab.active {\n  background-color: var(--primary-yellow);\n  color: black;\n  box-shadow: 0 4px 10px rgba(244, 180, 0, 0.3);\n}\n\n/* Icoane (adăugate prin pseudo-elemente pentru un aspect curat) */\n.tab[onClick*=\"posteaza\"]::before { content: '➕'; margin-right: 12px; }\n.tab[onClick*=\"lista\"]::before { content: '📋'; margin-right: 12px; }\n\n\n/* --- 2. Header-ul Superioar (Zonă Utilizator) --- */\n.dashboard-header {\n  grid-column: 2; /* Lângă sidebar */\n  background-color: var(--white);\n  padding: 20px 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(0,0,0,0.05);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Titlul paginii mutat în stânga header-ului */\n.dashboard-header-title-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard-header h1 {\n  font-size: 1.6rem;\n  font-weight: 700;\n  font-family: 'Baloo 2', cursive;\n  color: #f2c94c; /* galben */\n    text-shadow:\n    1px 1px 0 black,\n    -1px 1px 0 black,\n    1px -1px 0 black,\n    -1px -1px 0 black;\n}\n\n.dashboard-header p {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n}\n\n/* Zona de Profil din dreapta */\n.dashboard-user {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  background-color: var(--bg-main);\n  padding: 10px 20px;\n  border-radius: 50px; /* Stil \"pill\" profesional */\n}\n\n.dashboard-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid black;\n  object-fit: cover;\n}\n\n.dashboard-user span {\n  font-weight: 600;\n  color: var(--text-main);\n  font-size: 0.95rem;\n}\n\n.btn-logout {\n  background-color: transparent;\n  border: 1px solid #d1d9e0;\n  color: var(--text-muted);\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 600;\n  transition: var(--transition-fast);\n}\n\n.btn-logout:hover {\n  background-color: var(--red-alert);\n  color: var(--white);\n  border-color: var(--red-alert);\n  box-shadow: 0 2px 5px rgba(217, 48, 37, 0.3);\n}\n\n/* --- 3. Zona de Conținut Principal --- */\n.dashboard-content {\n  grid-column: 2; /* Lângă sidebar */\n  padding: 40px;\n  background-color: var(--bg-main);\n}\n\n/* Card-ul alb care conține formularele/listele */\n.formular-container, .lista-container {\n  background-color: var(--white);\n  padding: 30px;\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-md);\n  border: 1px solid rgba(0,0,0,0.03);\n}\n\n/* --- Stare de Încărcare (Loading) --- */\n.loading {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: var(--white);\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: var(--primary-yellow);\n}\n\n/* --- 📱 RESPONSIVE DESIGN (Media Queries) --- */\n\n/* Pentru Tablete și Ecrane Medii (sub 1024px) */\n@media (max-width: 1024px) {\n  .dashboard {\n    grid-template-columns: 1fr; /* O singură coloană */\n  }\n\n  /* Sidebar-ul devine o bară orizontală jos sau sus */\n  .dashboard-tabs {\n    grid-row: auto;\n    flex-direction: row;\n    justify-content: center;\n    padding: 15px;\n    border-right: none;\n    border-bottom: 1px solid rgba(0,0,0,0.05);\n    position: sticky;\n    top: 0;\n    margin-bottom: 0;\n  }\n\n  .dashboard-tabs::before {\n    display: none; /* Ascundem textul logo pe tab-uri mobile */\n  }\n\n  .tab {\n    padding: 10px 15px;\n    font-size: 0.9rem;\n    justify-content: center;\n  }\n\n  .dashboard-header, .dashboard-content {\n    grid-column: 1;\n  }\n}\n\n/* Pentru Telefoane (sub 768px) */\n@media (max-width: 768px) {\n  .dashboard-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 15px;\n    padding: 20px;\n  }\n\n  .dashboard-user {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .dashboard-content {\n    padding: 20px;\n  }\n\n  .formular-container, .lista-container {\n    padding: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
